import { defineMessages } from "react-intl";

export const AUDIT_LABELS = defineMessages({
  auditComplete: {
    id: "crossdock.boxAudit.auditComplete",
    defaultMessage: "Box {cdsku} audit completed",
  },
});
